<template>
    <div
        ref="wrapper"
        class="member-card"
        :class="{
            'member-card--outline': outline
        }"
    >
        <!-- <NuxtPicture
            :src="avatarSource"
            alt=""
            sizes="60px md:150px"
            width="60px"
            height="60px"
            loading="eager"
            decoding="async"
            class="member-card__avatar"
        /> -->
        <BaseAvatar
            class="member-card__avatar"
            :image="avatar"
        />
        <div class="member-card__body">
            <span class="member-card__name">{{ name }}</span>
            <span class="member-card__institute">{{ institute }}</span>
            <span class="member-card__function-title">{{ functionTitle }}</span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    avatar: {
        type: String,
        required: false,
        default: '/stock/default-avatar.png'
    },
    name: {
        type: String,
        required: true,
        default: null
    },
    institute: {
        type: String,
        required: false,
        default: null
    },
    functionTitle: {
        type: String,
        required: true,
        default: null
    },
    outline: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="less" src="./MemberCard.less" />
